// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryObjectBase } from "@msnews/telemetry-contracts";

import { genericTelemetryClickDispatcher, getPageContentType } from "../Social.telemetry";

export interface CommentTelemetryObjects {
    compactStartConversationButton: TelemetryObjectBase;
    compactJoinConversationButton: TelemetryObjectBase;
    overlayAddCommentButton: TelemetryObjectBase;
    overlayStartConversationButton: TelemetryObjectBase;
    overlayJoinConversationButton: TelemetryObjectBase;
    mobileFloaterButton: TelemetryObjectBase;
    overlayComments: TelemetryObjectBase;
}

export const commentTelemetryContracts = {
    /** Scenario-1: view, Scenario-2:click*/
    compactStartConversationButton: {
        name: "StartConversation",
        behavior: TelemetryBehaviorType.Open,
        content: {
            type: getPageContentType()
        }
    },
    /** Scenario-1: view, Scenario-3:click*/
    compactJoinConversationButton: {
        name: "JoinConversation",
        behavior: TelemetryBehaviorType.Open,
        content: {
            type: getPageContentType()
        }
    },
    /** Scenario-4: view, Scenario-5:click*/
    overlayAddCommentButton: {
        name: "AddCommentFloater",
        behavior: TelemetryBehaviorType.Open,
        content: {
            type: getPageContentType()
        }
    },
    /** Scenario-4: view, Scenario-6:click*/
    overlayStartConversationButton: {
        name: "StartConversationFloater",
        behavior: TelemetryBehaviorType.Open,
        content: {
            type: getPageContentType()
        }
    },
    /** Scenario-4: view, Scenario-7:click*/
    overlayJoinConversationButton: {
        name: "JoinConversationFloater",
        behavior: TelemetryBehaviorType.Open,
        content: {
            type: getPageContentType()
        }
    },
    /** Scenario-8: view, Scenario-8a:click*/
    mobileFloaterButton: {
        name: "CommentFloater",
        behavior: TelemetryBehaviorType.Open,
        content: {
            type: getPageContentType()
        }
    },
    /** Scenario-9: view */
    overlayComments: {
        name: "CommentOverlay",
        content: {
            type: getPageContentType()
        }
    }
};

export const commentTelemetryActionDispatchers = {
    genericClicked: genericTelemetryClickDispatcher
};